<template>
    <div class="components-container">
        <div class="filter-container">
            <el-input v-model="queryForm.stuCode" @keyup.enter.native="handleFilter" style="width:200px;" placeholder="学号 / 姓名" clearable></el-input>
            <el-input v-model="queryForm.className" @keyup.enter.native="handleFilter" style="width:200px;" placeholder="行政班名称" clearable></el-input>
            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button @click="confirmSelectStu" type="success"><i class="el-icon-circle-plus-outline"></i>&nbsp;确认添加</el-button>
        </div>

        <el-table :data="tableData" v-loading="tableLoading"
            row-key="stuCode"
            @current-change="handleCurrentChange"
            @row-click="handleRowClick"
            @selection-change="handleSelection"
            element-loading-text="信息加载中" highlight-current-row border style="width: 100%" height="530" ref="mainTable">
            <el-table-column type="selection" width="45">
            </el-table-column>
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{ (currentPage - 1) * limit + scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="学号" prop="stuCode" align="center" width="150px"></el-table-column>
            <el-table-column label="姓名" prop="stuName" align="center" width="150px"></el-table-column>
            <el-table-column label="行政班名称" prop="className" align="center" min-width="20%"></el-table-column>
            <el-table-column v-if="subjectFieldVisible" label="科目总数" prop="totalSubjectNum" align="center" width="100px"></el-table-column>
            <el-table-column v-if="subjectFieldVisible" label="合格科目数" prop="subjectNum" align="center" width="100px"></el-table-column>
            <el-table-column v-if="subjectFieldVisible" label="合格率" prop="subjectRatio" align="center" width="100px"></el-table-column>
            <el-table-column v-if="creditFieldVisible" label="总学分" prop="totalCredit" align="center" width="100px"></el-table-column>
            <el-table-column v-if="creditFieldVisible" label="获得学分" prop="credit" align="center" width="100px"></el-table-column>
            <el-table-column v-if="creditFieldVisible" label="得分率" prop="creditRatio" align="center" width="100px"></el-table-column>
            <el-table-column label="操作" align="center" width="100px">
                <template slot-scope="scope">
                    <el-button size="small" @click="showScoreList(scope.row);" type="primary">
                        <i class="el-icon-tickets"></i>&nbsp;成绩
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>

        <el-dialog title="科目成绩信息" :visible.sync="scoreDialogVisible" v-if="scoreDialogVisible" width="900px" top="150px" append-to-body>
            <div style="height:540px;">
                <el-table :data="scoreTableData" v-loading="tableLoading" element-loading-text="信息加载中"
                    highlight-current-row border style="width: 100%" height="500" ref="scoreTable">
                    <el-table-column label="序号" width="50" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="学年学期名称" prop="semesterName" align="center" width="200px"></el-table-column>
                    <el-table-column label="课程名称" prop="courseName" align="center" min-width="20%"></el-table-column>
                    <el-table-column label="成绩" prop="score" align="center" width="100px"></el-table-column>
                    <el-table-column label="学分" prop="credit" align="center" width="100px"></el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        props: ['graduateParam'],
        data() {
            return {
                subjectFieldVisible: false,
                creditFieldVisible: false,
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    stuCode: null,
                    stuName: null,
                    className: null,
                    mainCode: null,
                    year: null,
                    id: null,
                },
                tableData: [],
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                selectRowData: {},
                scoreDialogVisible: false,
                scoreTableData: [],
                invokeSelection: true,
                stuArray: [],
            };
        },
        mounted() {
            this.initData();
            this.queryList();

            this.$nextTick().then(() => {
                this.handleModel();
            });
        },
        methods: {
            initData(){
                this.queryForm.mainCode = this.graduateParam.mainCode;
                this.queryForm.year = this.graduateParam.year;
            },
            handleModel(){
                if(this.graduateParam.standardType === '02'){
                    this.creditFieldVisible = true;
                }else{
                    this.subjectFieldVisible = true;
                }
            },
            queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;

                this.invokeSelection = false;
                this.$api.student.graduate.stuList({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = response.data.data.list;
                    this.tableLoading = false;

                    this.$nextTick().then(() => {
                        this.tableData.forEach(row => {
                            for(let i=0; i<this.stuArray.length; i++){
                                if(this.stuArray[i].stuCode == row.stuCode){
                                    this.$refs.mainTable.toggleRowSelection(row);
                                    break;
                                }
                            }
                        });

                        this.invokeSelection = true;
                    });
                }).catch((error) => {
                    this.tableLoading = false;
                    this.invokeSelection = true;
                    console.log(error);
                });
            },
            handleFilter() {
                this.currentPage = 1;
                this.queryList();
            },
            handleReset() {
                this.limit = 10;
                this.currentPage = 1;
                this.queryForm.stuCode = null;
                this.queryForm.stuName = null;
                this.queryForm.className = null;
                this.tableLoading = false;
                this.queryList();
            },
            handlePageChange(val) {
                this.currentPage = val;
                this.queryList();
            },
            handleCurrentChange(val) {
               this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.queryList();
            },
            handleRowClick(row){
                this.$refs.mainTable.toggleRowSelection(row);
            },
            handleSelection(selection){
                //table加载期间不调用
                if(this.invokeSelection){
                    this.tableData.forEach(stu => {
                        for(let i=0; i<this.stuArray.length; i++){
                            if(this.stuArray[i].stuCode == stu.stuCode){
                                this.stuArray.splice(i, 1);
                                break;
                            }
                        }
                    });

                    selection.forEach(stu => {
                        this.stuArray.push(stu);
                    });
                }
            },
            confirmSelectStu(){
                if(this.stuArray.length < 1){
                    this.$message({
                        message: '请至少选择一名学生',
                        type: 'warning'
                    });

                    return;
                }

                let msg = '<div style="font-size:16px;">是否确定要添加以下学生到毕业学生名单</div>';
                msg += '<div style="height:200px; font-size:14px; margin:10px 0 10px 0; padding-left:20px; overflow:auto;">';
                for(let i=0; i<this.stuArray.length; i++){
                    msg += this.stuArray[i].stuName + ' - ' + this.stuArray[i].stuCode + '<br/>';
                }
                msg += '</div>';

                this.$confirm(msg, '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    customClass: 'confirm-box',
                    dangerouslyUseHTMLString: true,
                }).then(() => {
                    this.addStuRec();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消此操作'
                    });
                });
            },
            addStuRec(){
                let stuInfoArray = new Array();
                this.stuArray.forEach(stu => {
                    const stuInfo = {
                        mainCode: this.graduateParam.mainCode,
                        stuCode: stu.stuCode,
                        classCode: stu.classCode,
                        totalSubjectNum: stu.totalSubjectNum,
                        subjectNum: stu.subjectNum,
                        totalCredit: stu.totalCredit,
                        credit: stu.credit,
                        stuState: '07',
                    };

                    stuInfoArray.push(stuInfo);
                });

                const params = {
                    mainCode: this.graduateParam.mainCode,
                    stuInfo: stuInfoArray,
                };

                this.$api.student.graduate.addStu({
                    data: params,
                }).then((response) => {
                    let state = response.data.data.state;

                    if (state == 'Success') {
                        showNotify('成功', '添加成功', 'success', 1500);
                        this.$emit("closeAddStuDialog");
                    }else{
                        showNotify('失败', '添加失败', 'error', 3000);
                    }
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            showScoreList(rowData){
                this.queryForm.id = rowData.stuCode;
                this.scoreDialogVisible = true;
                this.queryScoreList();

                this.$refs.mainTable.toggleRowSelection(rowData);
            },
            queryScoreList(){
                this.tableLoading = true;

                this.$api.student.graduate.scoreList({
                    data: this.queryForm,
                }).then((response) => {
                    this.scoreTableData = response.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// graduateAddStu.vue?11d2eb43